// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run pnpm gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../../../schema/public';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type BestGameOfTheWeekQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.ContentPageConnectionFilter>;
}>;


export type BestGameOfTheWeekQuery = { __typename?: 'Query', content?: { __typename?: 'Content', id: string, pages?: { __typename?: 'ContentPageConnection', edges?: Array<{ __typename?: 'ContentPageEdge', node?: { __typename?: 'ContentPage', id: string, title?: string, img?: string, bgColor?: string, gameHandle?: string } }> } } };

export type HighlightedGameQueryVariables = Types.Exact<{
  filter: Types.CasinoGameConnectionFilter;
}>;


export type HighlightedGameQuery = { __typename?: 'Query', casino?: { __typename?: 'Casino', id: string, games?: { __typename?: 'CasinoGameConnection', edges?: Array<{ __typename?: 'CasinoGameEdge', node?: { __typename?: 'CasinoGame', id: string, name?: string, href?: string, provider?: Array<{ __typename?: 'CasinoGameMenuItem', id: string, name?: string }> } }> } } };


export const BestGameOfTheWeekQueryDocument = /*#__PURE__*/ gql`
    query BestGameOfTheWeekQuery($filter: ContentPageConnectionFilter) {
  content {
    id
    pages(first: 1, filter: $filter) {
      edges {
        node {
          id
          title
          img: smallImage
          bgColor: mediumImage
          gameHandle: games
        }
      }
    }
  }
}
    `;
export function useBestGameOfTheWeekQuery(baseOptions?: Apollo.QueryHookOptions<BestGameOfTheWeekQuery, BestGameOfTheWeekQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BestGameOfTheWeekQuery, BestGameOfTheWeekQueryVariables>(BestGameOfTheWeekQueryDocument, options);
      }
export function useBestGameOfTheWeekQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BestGameOfTheWeekQuery, BestGameOfTheWeekQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BestGameOfTheWeekQuery, BestGameOfTheWeekQueryVariables>(BestGameOfTheWeekQueryDocument, options);
        }
export function useBestGameOfTheWeekQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BestGameOfTheWeekQuery, BestGameOfTheWeekQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BestGameOfTheWeekQuery, BestGameOfTheWeekQueryVariables>(BestGameOfTheWeekQueryDocument, options);
        }
export type BestGameOfTheWeekQueryHookResult = ReturnType<typeof useBestGameOfTheWeekQuery>;
export type BestGameOfTheWeekQueryLazyQueryHookResult = ReturnType<typeof useBestGameOfTheWeekQueryLazyQuery>;
export type BestGameOfTheWeekQuerySuspenseQueryHookResult = ReturnType<typeof useBestGameOfTheWeekQuerySuspenseQuery>;
export type BestGameOfTheWeekQueryQueryResult = Apollo.QueryResult<BestGameOfTheWeekQuery, BestGameOfTheWeekQueryVariables>;
export const HighlightedGameQueryDocument = /*#__PURE__*/ gql`
    query HighlightedGameQuery($filter: CasinoGameConnectionFilter!) {
  casino {
    id
    games(first: 1, filter: $filter, hrefPrefix: "/play") {
      edges {
        node {
          id
          name
          href
          provider: menuItem(section: 1) {
            id
            name
          }
        }
      }
    }
  }
}
    `;
export function useHighlightedGameQuery(baseOptions: Apollo.QueryHookOptions<HighlightedGameQuery, HighlightedGameQueryVariables> & ({ variables: HighlightedGameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HighlightedGameQuery, HighlightedGameQueryVariables>(HighlightedGameQueryDocument, options);
      }
export function useHighlightedGameQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HighlightedGameQuery, HighlightedGameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HighlightedGameQuery, HighlightedGameQueryVariables>(HighlightedGameQueryDocument, options);
        }
export function useHighlightedGameQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HighlightedGameQuery, HighlightedGameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HighlightedGameQuery, HighlightedGameQueryVariables>(HighlightedGameQueryDocument, options);
        }
export type HighlightedGameQueryHookResult = ReturnType<typeof useHighlightedGameQuery>;
export type HighlightedGameQueryLazyQueryHookResult = ReturnType<typeof useHighlightedGameQueryLazyQuery>;
export type HighlightedGameQuerySuspenseQueryHookResult = ReturnType<typeof useHighlightedGameQuerySuspenseQuery>;
export type HighlightedGameQueryQueryResult = Apollo.QueryResult<HighlightedGameQuery, HighlightedGameQueryVariables>;